import * as React from 'react';
import config from '../../../config';
 
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PrintIcon from '@mui/icons-material/Print';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add'
import {createInspectionLink} from "../../../helpers"
import ServerDataGrid from '../../../Components/ServerDataGrid';
import EditInspection from "./editinspectionData";
import AddInspection from "./addinspectionData"
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useCallback } from 'react';
import { getMyInspectionPaginated, UpdateSimulateInspection } from '../../../REST/inspections';
import moment from 'moment';
import PageShell from '../../../themes/components/PageShell';
import PageHeader from '../../../themes/components/PageHeader';
import PageContent from '../../../themes/components/PageContent';
import Action from '../../../themes/components/Action';
 
export default function InspectionList(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [add, setAdd] =  useState(null);  
    const [edit, setEdit] =  useState(null);     
    const [refresh, setRefresh] =  useState(false);    
    const id = location.pathname.replace("/inspection/inspectionList/","")
    
    const handleEdit  = (params)=>{
        setEdit(params.row._id)
       
    }
    const handleReview = (params)=>{

    }
    const handleView = (params)=>{
        const inspectionId = params.row._id
        const link = createInspectionLink(inspectionId,true)
        window.open(link,"_blank" )
    }
    const handlePrint = (params) => {
        const id = params.row._id
        const link = config.REACT_APP_API_URL + "/api/Inspection/print/" + id
        window.open(link, "_blank")
    }
    const handleComplete = (params)=>{
        UpdateSimulateInspection(params.row._id,{status:"Completed"})
        .then(()=>{
            setRefresh(!refresh)
           
        })
    }
    
    const fetchInspections = useCallback(async (page, limit, filters, sort) => {
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        try {
            const result = await getMyInspectionPaginated(id, params)
            
            if (result.data?.data) {
                return {
                    data: result.data.data,
                    pagination: result.data.pagination
                }
            }
            
            return { data: [], pagination: { total: 0, page: 1, pages: 1 } }
        } catch (error) {
            console.log(error)
            navigate("/inspection")
            return { data: [], pagination: { total: 0, page: 1, pages: 1 } }
        }
    }, [id, refresh, navigate]) 
    const getColumns = ()=>{
        let cols = []
       cols.push(
        {
            field: "_id",
            headerName: "Action",
            sortable: false,
            filterable: false,
            width: 150,
            minVisible: 'xs',
            renderCell: (params) => {
               return(
               <>
               <IconButton title={"View Inspection"} 
                    onClick={(evt ) => {evt.preventDefault(); handleView(params) }} >
                        <ContentPasteGoIcon style={{ fontSize: 16 }} />
                </IconButton>
                <IconButton title={"Print Inspection"} onClick={(evt) => { evt.preventDefault(); handlePrint(params) }}>
                    <PrintIcon style={{ fontSize: 16 }} />
                </IconButton>
                {
                     params.row.status != "Completed" && <IconButton title={"Edit Inspection"} 
                     onClick={(evt ) => {evt.preventDefault(); handleEdit(params) }} ><EditIcon style={{ fontSize: 16 }} /></IconButton>
                
                }
                {
                    params.row.status != "Completed" && 
                    <IconButton title={"Complete Inspection"} 
                    onClick={(evt ) => {evt.preventDefault(); handleComplete(params) }} ><DoneAllIcon style={{ fontSize: 16 }} /></IconButton>
               
                }
                {
                     params.row.status == "Completed" &&
                     <IconButton title={"View Inspection"}   
                     onClick={(evt ) => {evt.preventDefault();handleReview(params)}}><VisibilityIcon style={{ fontSize: 16 }} /></IconButton>
                
                }
                </>
        
               )
            }
          }

       ) 
        cols.push({field:"inspectiontype",headerName:"Inspection Type", flex: 0.3, minVisible: 'md'})
        cols.push({field:"status",headerName:"Inspection Status", flex: 0.3, type: 'singleSelect', valueOptions: ['Created', 'In Progress', 'Completed'], minVisible: 'md'})  
        cols.push({field:"name",headerName:"Inspector Name", flex: 0.3, minVisible: 'xs'})  
        cols.push({field:"email",headerName:"Inspector Email", flex: 0.4, minVisible: 'xs'}) 
        cols.push({ 
            field: 'createdAt', 
            headerName: 'Created On', 
            flex: 0.3,
            filterable: false,
            sortable: true,
            minVisible: 'lg',
            valueGetter: (params) => moment(params.row.createdAt).format("MM/DD/yyyy HH:ss") 
        }); 
          
      
        return cols;    
    }
  
   const handleCloseAdd = (ret)=>{
        setAdd(null)
        if(ret) setRefresh(!refresh)
       
   }
   const handleCloseEdit = (ret) =>{
        setEdit(null)
        if(ret) setRefresh(!refresh)
   }
    return (
        <PageShell>
            <PageHeader
                title="Inspections"
                back
                onBack={() => navigate(-1)}
                actions={
                    <Action
                        primary
                        icon={<AddIcon />}
                        label="Add New Inspection"
                        onClick={() => setAdd(id)}
                    />
                }
            />
            <PageContent fill>
                <div style={{ height: '100%' }}>
                    <ServerDataGrid
                        columns={getColumns()}
                        fetchData={fetchInspections}
                        initialPageSize={10}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        getRowId={(row) => row._id}
                    />
                </div>
            </PageContent>

            
            {
                add != null && <AddInspection id={add}  handleClose={handleCloseAdd} />
            }
            {
                edit != null && <EditInspection  id={edit} handleClose={handleCloseEdit}  />
            }
        </PageShell>
        
         
    );
}
